import { useMemo } from 'react';

import { CurrencyFormatter, EXCEPTIONS } from '@pp/core/src/formatters/CurrencyFormatter';
import { useHideCurrency } from '@pp/core/src/store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';

const CURRENCY_WITH_NUMERICS: string[] = ['DOG6'];

const OTHER_THAN_NUMBERS_AND_PUNCTUATION = /[\d\u0660-\u066C\u06F0-\u06F9\p{P}   _]+/gu;

export const useCurrencySymbol = (): string => {
  const currency = useGameStateSlice.getCurrency() ?? '';
  const currentLanguage = useSettingsSlice.currentLanguage();
  const currencySymbol = useGameStateSlice.getCurrencyInfo()?.symbol;
  const hideCurrency = useHideCurrency();

  return useMemo(() => {
    if (!currencySymbol || hideCurrency) return '';

    let finalCurrencySymbol;
    if (CURRENCY_WITH_NUMERICS.includes(currencySymbol)) {
      finalCurrencySymbol = currencySymbol;
    } else if (EXCEPTIONS[currencySymbol]) {
      finalCurrencySymbol = CurrencyFormatter.format(0, currentLanguage, { currency: currency, hideCurrency })
        .replace(EXCEPTIONS[currency].original, EXCEPTIONS[currency].replacement)
        .replace(OTHER_THAN_NUMBERS_AND_PUNCTUATION, '')
        .trim();
    } else {
      finalCurrencySymbol = CurrencyFormatter.format(0, currentLanguage, { currency: currency, hideCurrency })
        .replace(OTHER_THAN_NUMBERS_AND_PUNCTUATION, '')
        .trim();
    }
    return finalCurrencySymbol;
  }, [currency, currencySymbol, currentLanguage, hideCurrency]);
};
